import { useQuery } from "@tanstack/react-query";
import { formatMoney } from "@melhot/shared/money";
import { adminApi } from "../api";
import { EmptyState, Panel } from "../components/DataTable";

export function PaymentsPage() {
  const query = useQuery({ queryKey: ["admin-payments"], queryFn: adminApi.payments, refetchInterval: 5000 });
  return (
    <Panel title="Pagamentos PIX">
      {!query.data?.length ? <EmptyState text="Nenhum pagamento PIX criado." /> : (
        <div className="overflow-auto">
          <table className="w-full min-w-[820px] text-left text-sm">
            <thead className="text-xs uppercase text-slate-500"><tr><th className="py-2">ID</th><th>Provider</th><th>Status</th><th>Valor</th><th>Expira</th><th>Pago em</th></tr></thead>
            <tbody>
              {query.data.map((item) => (
                <tr key={item.id} className="border-t border-line">
                  <td className="py-2 font-mono text-xs">{item.id}</td>
                  <td>{item.provider}</td>
                  <td>{item.status}</td>
                  <td>{formatMoney(item.amount ?? 0)}</td>
                  <td>{new Date(item.expiresAt).toLocaleString("pt-BR")}</td>
                  <td>{item.paidAt ? new Date(item.paidAt).toLocaleString("pt-BR") : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
